import { useEffect,useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Link,useLocation } from "react-router-dom";

import { Pagination,Table } from "antd";
import { formatDateHandler2,toTitleCase } from "utils/common";
import { itemRender,pageSizeOptions } from "utils/table";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import AllDocumentAddPopup from "../../../../components/modelpopup/AllDocumentAddPopup";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import DocumentListFilter from "../components/DocumentListFilter";
import DocumentStatsBar, { tileToFilterEntries } from "../components/DocumentStatsBar";
import DocumentStatusBadge from "../components/DocumentStatusBadge";
import ExpiryBadge from "../components/ExpiryBadge";
import GroupByControl from "../components/GroupByControl";
import { getExpiryMeta } from "../components/expiry";
import { GROUP_BY, USER_GROUP_OPTIONS, collapseAllGroups, expandAllGroups, isGrouped, rowsFromGroups, toggleGroupCollapse } from "../components/grouping";

import { deleteDocumentApi, exportDocumentsApi } from "api/services/documents";
import { Button } from "components/Button";
import DocumentsFilterDrawer from "components/Drawer/documentsFilterDrawer";
import Image from "components/Image";
import { SkeltonLoader } from "components/skeltonLoader";
import { useSelector } from "react-redux";
import { Bounce,toast } from "react-toastify";
import { useDocument } from "../context/documentContext";

const AllDocuments = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const location = useLocation();
  const {
    loading,
    setLoading,
    searchText,
    documentData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleSortChange,
    handleTablePageChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,

    handleDocumentDetailPage,
    handleDateChange,
    handleClearAll,
    createDocumentHandler,
    documentModal,
    setDocumentModal,
    setSelectedDocument,
    selectedDocument,
    getDocumentList,

    documentType,
    storeType,
    documentTypeLoading,
    setStoreType,
    resetDocumentList,
    getExportParams,
    isFilterDirty,
    documentStats,
    statsLoading,
    applyFilterValues,
    refreshDocuments,
    setDocumentArchived,
    appliedExpiryFilters,
    getDocumentStats,
    handleGroupByChange,
    documentGroups,
    groupCollapse,
    setGroupCollapse,
  } = useDocument();
  const {
    user,
    userLoading
  } = useSelector((state) => state.user);
  const [deleteModal, setDeleteModal] = useState(false);
  // Grouping is a table feature; the grid always shows a flat list.
  const groupBy = view === "list" ? (pageSettings?.groupBy || "") : "";

  const handleEditDocument = (item) => {
    setDocumentModal(true);
  };
  const openDocument = (record) =>
    handleDocumentDetailPage(record.id, documentData.findIndex((doc) => doc.id === record.id));

  const ProfileLink = ({ employee }) =>
    employee?.id ? (
      <Link
        to={`/employees/${employee.id}`}
        onClick={(e) => e.stopPropagation()}
        title="Open employee profile"
        aria-label={`Open profile of ${employee.first_name || ""} ${employee.last_name || ""}`.trim()}
        className="doc-profile-link"
      >
        <i className="las la-user-circle" aria-hidden="true" />
      </Link>
    ) : null;

  const toggleGroup = (key) => setGroupCollapse((prev) => toggleGroupCollapse(prev, key));

  const renderGroupHeader = (group) => {
    const { employee, costCenter } = group;
    const isEmployeeGroup = group.groupBy === GROUP_BY.EMPLOYEE;
    const isSub = group.level > 0;
    return (
      <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px", paddingLeft: isSub ? "28px" : 0 }}>
        <button
          type="button"
          className="doc-group-toggle"
          onClick={() => toggleGroup(group.key)}
          aria-expanded={!group.collapsed}
          aria-label={group.collapsed ? "Expand group" : "Collapse group"}
        >
          <i className={`las ${group.collapsed ? "la-angle-right" : "la-angle-down"}`} aria-hidden="true" />
        </button>
        {isEmployeeGroup ? (
          employee ? (
            <>
              <Image
                src={employee.profile_image}
                type="user"
                style={{ width: isSub ? "24px" : "28px", height: isSub ? "24px" : "28px", borderRadius: "50%", objectFit: "cover" }}
              />
              <span style={{ fontWeight: 600, color: "#1f2937" }}>
                {employee.first_name} {employee.last_name}
              </span>
              <span className="small text-muted d-inline-flex align-items-center" style={{ gap: "5px" }}>
                {employee.emp_no}
                <ProfileLink employee={employee} />
              </span>
              {employee.position_name && <span className="small text-muted">· {employee.position_name}</span>}
              {!isSub && costCenter?.name && <span className="small text-muted">· {costCenter.name}</span>}
            </>
          ) : (
            <span style={{ fontWeight: 600, color: "#1f2937" }}>No employee</span>
          )
        ) : costCenter ? (
          <>
            <i className="las la-store" aria-hidden="true" style={{ fontSize: "18px", color: "#6b7280" }} />
            <span style={{ fontWeight: 600, color: "#1f2937" }}>{costCenter.name}</span>
            {costCenter.code && <span className="small text-muted">{costCenter.code}</span>}
          </>
        ) : (
          <span style={{ fontWeight: 600, color: "#1f2937" }}>No cost center</span>
        )}
        <span className="small text-muted">
          · {group.count} {group.count === 1 ? "document" : "documents"}
        </span>
        {group.expired > 0 && <span className="badge badge-soft-danger">{group.expired} expired</span>}
        {group.attention > 0 && (
          <span className="badge badge-soft-warning">{group.attention} due within 7 days</span>
        )}
      </div>
    );
  };

  const columns = [
    {
      title: "Employee Name",
      key: "employee",
      dataIndex: "company_user__user__first_name",
      sorter: true,
      render: (text, record) => (
        <h2 className="table-avatar d-flex">
          <a onClick={() => openDocument(record)} className="avatar">
            <Image src={record.company_user?.profile_image} type="user" style={{ objectFit: "cover" }} />
          </a>
          <div className="profile-split d-flex flex-column">
            <a onClick={() => openDocument(record)}>
              {record.company_user?.first_name} {record.company_user?.last_name}
            </a>
            <span className="small text-muted d-inline-flex align-items-center" style={{ gap: "5px" }}>
              {record.company_user?.emp_no}
              <ProfileLink employee={record.company_user} />
            </span>
          </div>
        </h2>
      ),
    },
    {
      title: "Cost Center",
      key: "cost_center",
      dataIndex: "company_user__cost_center__name",
      sorter: true,
      render: (text, record) =>
        record.cost_center ? (
          <div className="d-flex flex-column">
            <span>{record.cost_center.name}</span>
            {record.cost_center.code && <span className="small text-muted">{record.cost_center.code}</span>}
          </div>
        ) : (
          <span className="text-muted">-</span>
        ),
    },
 
    {
      title: "Document Name",
      dataIndex: "name",
      sorter: true,

      render: (text, record) => (
        <a onClick={() => openDocument(record)} className="table-avatar" style={{ cursor: "pointer" }}>
          {record.name}
        </a>
      ),
    },

    // {
    //   title: "Document No",
    //   dataIndex: "document_number",
    //   render: (text, record) => (
    //     <span className="table-avatar">{record.document_number}</span>
    //   ),
    // },

    {
      title: "Type",
      dataIndex: "document_type__name",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
          <span className="badge badge-soft-info">
            {record.document_type?.name}
          </span>
        </div>
      ),
    },

    {
 title: "Attachments",
      dataIndex: "document_sub_type",
      // sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
        <span className="small text-muted">
              {" "}
              <i class="fa-solid fa-paperclip" /> {record.attachments_count}{" "}
              Attachments{" "}
            </span>
        </div>
      ),
    },
    

    {
      title: "Issue Date",
      dataIndex: "issue_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.issue_date)}
        </span>
      ),
    },

    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.expiry_date)}
        </span>
      ),
    },
    {
      title: "Expires In",
      // expiry_in_days is computed from expiry_date on the backend, so
      // sorting by expiry_date gives the same order server-side.
      dataIndex: "expiry_date",
      key: "expiry_in_days",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <ExpiryBadge document={record} />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
          <DocumentStatusBadge document={record} />
        </div>
      ),
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.description}
    //     </span>
    //   )

    // },
    {
      title: "Action",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {/* <Link
            onClick={()=>{
              handleEditDocument(recort)
              setDocumentModal(true)
              // setSelectedDocument(record)

            }}
              // to="#"
              className="dropdown-item"
              // data-bs-toggle="modal"
              // data-bs-target="#edit_job"
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link> */}
            {(user?.role?.access_scope == "all" || user?.id == record?.company_user?.id) && (
              <Link
                onClick={() => setDocumentArchived(record.id, record.status !== false)}
                to="#"
                className="dropdown-item"
              >
                <i className={`las ${record.status === false ? "la-box-open" : "la-archive"} m-r-5`} />
                {record.status === false ? "Restore" : "Archive"}
              </Link>
            )}
            {
                (user?.role?.access_scope == "all" || user?.id == record?.company_user?.id )&&
              <Link
              onClick={() => {
                setDeleteModal(true);
                setSelectedDocument(record);
              }}
              to="#"
              className="dropdown-item"
              // data-bs-toggle="modal"
              // data-bs-target="#delete"
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link>
            }
          
          </div>
        </div>
      ),
    },
  ];
  // The grouped-by column is redundant inside its own group header; under
  // cost centre the employee is carried by the sub-group header too.
  const visibleColumns = columns.filter(
    (col) =>
      !(groupBy === GROUP_BY.EMPLOYEE && col.key === "employee") &&
      !(groupBy === GROUP_BY.COST_CENTER && (col.key === "cost_center" || col.key === "employee"))
  );
  // Group header rows span the whole table: the first cell gets every
  // column's width and the rest collapse to nothing.
  const tableColumns = isGrouped(groupBy)
    ? visibleColumns.map((col, idx) => ({
        ...col,
        onCell: (record) => (record.__group ? { colSpan: idx === 0 ? visibleColumns.length : 0 } : {}),
        render: (text, record, index) =>
          record.__group ? (idx === 0 ? renderGroupHeader(record) : null) : col.render ? col.render(text, record, index) : text,
      }))
    : visibleColumns;
  const tableRows = isGrouped(groupBy) ? rowsFromGroups(documentGroups, groupCollapse) : documentData;
  const groupRows = tableRows.filter((row) => row.__group && !row.level);
  const allGroupsCollapsed = groupRows.length > 0 && groupRows.every((row) => row.collapsed);
  const clearAllFilters = () =>
    applyFilterValues(filters.filter((f) => f.key !== "search").map((f) => ({ key: f.key, data: "" })));

  useEffect(()=>{
    // Only reset on initial mount, not on every render
    const currentUser = new URLSearchParams(window.location.search).get("company_user");
    if (!currentUser) {
    resetDocumentList()
    }
    setStoreType("user")
  },[])
  
  // Reset when navigating back to this page from detail page
  useEffect(() => {
    if (location.pathname === '/documents' || location.pathname === '/documents/') {
      const currentUser = new URLSearchParams(window.location.search).get("company_user");
      // If URL doesn't have company_user but state does, reset
      if (!currentUser && pageSettings?.user) {
        resetDocumentList();
      }
    }
  }, [location.pathname])
  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
         {
          documentData.length == 0 &&
          <div className="row">
            <div className="col-12">
              <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                <a>No documents found</a>
              </h4>
            </div>
          </div>
        }
          {documentData.map((document, index) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-3"
              key={document.id}
              style={{
                ...(isMobile ? { paddingLeft: "4px", paddingRight: "4px", marginBottom: "12px" } : { marginBottom: "16px" }),
                display: "flex"
              }}
            >
              <div className="card shadow-sm" style={{ 
                borderRadius: "8px", 
                border: "none",
                borderLeft: `3px solid ${{ today: "#dc2626", expired: "#f87171", soon: "#f59e0b" }[getExpiryMeta(document).state] || "transparent"}`,
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                margin: 0,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.2s ease",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
              }}
              onClick={() => handleDocumentDetailPage(document.id, index)}
              >
                {/* Action Menu */}
                <div style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  zIndex: 10
                }}>
                  <div className="dropdown">
                  <Link
                      to="#"
                    className="action-icon dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "6px",
                        background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#ffffff",
                        textDecoration: "none",
                        boxShadow: "0 2px 6px rgba(211, 0, 26, 0.3)",
                        cursor: "pointer",
                        transition: "all 0.2s ease"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.1)";
                        e.currentTarget.style.boxShadow = "0 4px 10px rgba(211, 0, 26, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow = "0 2px 6px rgba(211, 0, 26, 0.3)";
                      }}
                    >
                      <i className="fa-solid fa-ellipsis-vertical" style={{ fontSize: "12px" }}></i>
                    </Link>
                    <div className="dropdown-menu dropdown-menu-right">
                      {(user?.role?.access_scope == "all" || user?.id == document?.company_user?.id) && (
                    <Link
                      className="dropdown-item"
                          onClick={(e) => {
                            e.stopPropagation();
                        setDeleteModal(true);
                        setSelectedDocument(document);
                      }}
                          to="#"
                    >
                      <i className="fa-regular fa-trash-can m-r-5" /> Delete
                    </Link>
                      )}
                    </div>
                  </div>
                </div>

                <div className="card-body" style={{ 
                  padding: isMobile ? "12px" : "16px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column"
                }}>
                  {/* Document Name - Main Highlight */}
                  <div style={{ marginBottom: "12px", paddingRight: "36px" }}>
                    <h4 style={{ 
                      fontSize: isMobile ? "15px" : "16px",
                      fontWeight: "600",
                      color: "#1f2937",
                      marginBottom: "6px",
                      lineHeight: "1.3"
                    }}>
                      {document?.name || "Untitled Document"}
                    </h4>
                    {document?.document_type?.name && (
                      <span style={{
                        fontSize: "12px",
                        color: "#6b7280",
                        fontWeight: "400"
                      }}>
                        {document.document_type.name}
                      </span>
                    )}
                  </div>

                  {/* Employee Info */}
                  {document?.company_user && (
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "12px"
                    }}>
                      <div style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        border: "2px solid #e5e7eb",
                        flexShrink: 0,
                        background: "#ffffff"
                      }}>
                        <Image 
                          src={document.company_user?.profile_image} 
                          type="user" 
                          style={{ objectFit: "cover", width: "100%", height: "100%" }}
                        />
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ 
                          fontSize: "13px", 
                          color: "#1f2937",
                          fontWeight: "600",
                          marginBottom: "2px"
                        }}>
                          {document.company_user?.first_name} {document.company_user?.last_name}
                        </div>
                        <div style={{ 
                          fontSize: "11px", 
                          color: "#6b7280",
                          marginBottom: "2px"
                        }}>
                          {document.company_user?.emp_no}
                        </div>
                        {document.company_user?.position_name && (
                          <div style={{ 
                            fontSize: "11px", 
                            color: "#6b7280",
                            marginBottom: "2px"
                          }}>
                            {document.company_user.position_name}
                          </div>
                        )}
                        {document.company_user?.email && (
                          <div style={{ 
                            fontSize: "11px", 
                            color: "#6b7280"
                          }}>
                            {document.company_user.email}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Document Details */}
                  <div style={{ marginTop: "auto" }}>
                    <div className="row g-2" style={{ marginBottom: "10px" }}>
                      {document?.issue_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-calendar" style={{ marginRight: "4px" }}></i>
                            Issue Date
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(document.issue_date)}
                          </div>
                        </div>
                      )}
                      {document?.expiry_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "10px", color: "#9ca3af", marginBottom: "3px", fontWeight: "500" }}>
                            <i className="la la-calendar-check" style={{ marginRight: "4px" }}></i>
                            Expiry Date
                          </div>
                          <div style={{ fontSize: "11px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(document.expiry_date)}
                          </div>
                          <div style={{ marginTop: "4px" }}>
                            <ExpiryBadge document={document} />
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Attachments and Status */}
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "space-between", 
                      alignItems: "center"
                    }}>
                      {document?.attachments_count !== undefined && (
                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <i className="fa-solid fa-paperclip" style={{ fontSize: "11px", color: "#6b7280" }}></i>
                          <span style={{ fontSize: "11px", color: "#6b7280", fontWeight: "500" }}>
                            {document.attachments_count} {document.attachments_count === 1 ? 'File' : 'Files'}
                          </span>
                    </div>
                      )}
                      <DocumentStatusBadge document={document} style={{ fontSize: "10px" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  const deleteHandler = (props) => {
    console.log(selectedDocument, "LLLLLLLL");
    deleteDocumentApi(selectedDocument?.id)
      .then((res) => {
        toast.success("Document deleted successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        refreshDocuments();
        setDeleteModal(false);
      })
      .catch((e) => {
        toast.error("Error deleting document!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      });
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle={toTitleCase(storeType) + " Documents"}
            title="Dashboard"
            subtitle="Documents"
            modal="#add_document"
            name="Add Document"
            view={view}
            setDocumentModal={setDocumentModal}
            setView={setView}
          />

          <DocumentStatsBar
            stats={documentStats}
            loading={statsLoading}
            applied={appliedExpiryFilters}
            onSelect={(tile) => applyFilterValues(tileToFilterEntries(tile))}
            onRetry={() => getDocumentStats(true)}
          />

          <DocumentListFilter
            filters={filters}
            handleInputChange={handleInputChange}
            searchPlaceholder={"Search Documents"}
            handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
            storeType={storeType}
            setStoreType={setStoreType}
            documentType={documentType}
            exportApiFn={exportDocumentsApi}
            exportParams={getExportParams()}
            exportFilename={`${toTitleCase(storeType)} Documents.xlsx`}
            onClearAll={clearAllFilters}
          />

          {view == "grid" ? (
            <div className="row">
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12">
                <GroupByControl
                  value={groupBy}
                  onChange={handleGroupByChange}
                  options={USER_GROUP_OPTIONS}
                  groupCount={groupRows.length}
                  allCollapsed={allGroupsCollapsed}
                  onExpandAll={() => setGroupCollapse(expandAllGroups())}
                  onCollapseAll={() => setGroupCollapse(collapseAllGroups())}
                />
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <style>{`
                    .modern-table .ant-table-tbody > tr {
                      background-color: #ffffff !important;
                    }
                    .modern-table .ant-table-tbody > tr.doc-group-row { background-color: #f3f4f6 !important; }
                    .modern-table .ant-table-tbody > tr.doc-group-row--sub { background-color: #fafafa !important; }
                    .modern-table .ant-table-tbody > tr.doc-group-row > td,
                    .modern-table .ant-table-tbody > tr.doc-group-row:hover > td {
                      background-color: transparent !important;
                      border-bottom: 1px solid #e5e7eb;
                      padding: 8px 12px;
                    }
                    .doc-group-toggle {
                      width: 24px; height: 24px; border: none; border-radius: 6px;
                      background: #ffffff; color: #374151;
                      display: inline-flex; align-items: center; justify-content: center;
                      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08); cursor: pointer;
                    }
                    .doc-group-toggle:focus-visible { outline: 2px solid rgb(211, 0, 26); outline-offset: 2px; }
                    .doc-profile-link { color: rgb(211, 0, 26); font-size: 15px; line-height: 1; display: inline-flex; }
                    .doc-profile-link:hover { color: #9f0014; }
                    .modern-table .ant-table-tbody > tr:hover > td {
                      background-color: #f5f5f5 !important;
                    }
                    /* Expiry row tints; the Expires In badge carries the same
                       meaning in text so colour is never the only signal. */
                    .modern-table .ant-table-tbody > tr.doc-row-expired { background-color: #fff1f2 !important; }
                    .modern-table .ant-table-tbody > tr.doc-row-today { background-color: #fee2e2 !important; }
                    .modern-table .ant-table-tbody > tr.doc-row-soon { background-color: #fffbeb !important; }
                    .modern-table .ant-table-tbody > tr.doc-row-expired > td,
                    .modern-table .ant-table-tbody > tr.doc-row-today > td,
                    .modern-table .ant-table-tbody > tr.doc-row-soon > td { background-color: transparent !important; }
                    .modern-table .ant-table-tbody > tr.doc-row-expired:hover > td,
                    .modern-table .ant-table-tbody > tr.doc-row-today:hover > td,
                    .modern-table .ant-table-tbody > tr.doc-row-soon:hover > td { background-color: rgba(0, 0, 0, 0.04) !important; }
                    .modern-table .ant-table-tbody > tr.doc-row-archived > td { color: #9ca3af; }
                    .modern-table .ant-table-thead > tr > th {
                      background-color: #f8f9fa !important;
                      font-weight: 600;
                      color: #333;
                      border-bottom: 2px solid #e0e0e0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #f0f0f0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                      border-top: 1px solid #f0f0f0;
                      background-color: #ffffff;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    }
                  `}</style>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={tableColumns}
                      dataSource={tableRows}
                      rowKey={(record) => (record.__group ? record.key : record.id)}
                      rowClassName={(record) =>
                        record.__group
                          ? `doc-group-row${record.level ? " doc-group-row--sub" : ""}${record.collapsed ? " is-collapsed" : ""}`
                          : record.status === false ? "doc-row-archived" : getExpiryMeta(record).rowClass
                      }
                      loading={loading}
                      pagination={false}
                      onChange={(tablePagination, tableFilters, sorter) => handleSortChange(sorter)}
                    />
                  </div>
                  {/* Pager outside the table: antd would otherwise slice a
                      grouped page (groups + their documents) to pageSize rows. */}
                  <div className="d-flex justify-content-end" style={{ padding: "16px", borderTop: "1px solid #f0f0f0" }}>
                    <Pagination
                      total={pageSettings?.total}
                      pageSize={Number(pageSettings?.pageSize) || 50}
                      current={Number(pageSettings?.page) || 1}
                      showSizeChanger
                      pageSizeOptions={pageSizeOptions}
                      itemRender={itemRender}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} of ${total} ${isGrouped(groupBy) ? "groups" : "items"}`}
                      onChange={handleTablePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}


          <AllDocumentAddPopup
            documentType={documentType}
            documentTypeLoading={documentTypeLoading}
            getDocumentList={refreshDocuments}
            setSelectedDocument={setSelectedDocument}
            setLoading={setLoading}
            selectedDocument={selectedDocument}
            loading={loading}
            createDocumentHandler={createDocumentHandler}
            documentModal={documentModal}
            setDocumentModal={setDocumentModal}
            storeType={storeType}
          />
          {/* Delete Modal */}
          <DeleteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            deleteHandler={deleteHandler}
            Name="Delete Record"
          />
        </div>
      </div>

      <DocumentsFilterDrawer
        searchPlaceholder={"Search Documents"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}
        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
        handleClearAll={handleClearAll}
        documentType={documentType}
        storeType={storeType}
        isFilterDirty={isFilterDirty}
        applyFilterValues={applyFilterValues}
      />
      {/* Delete Modal */}
    </>
  );
};

export default AllDocuments;
